import React, { FC, useState, useEffect } from 'react';
import { apiService } from 'utils/api';
import SurgeApplyNowSection from '../surge-tabs/surge-apply-now';
import SurgeScheduleSection from '../surge-tabs/surge-schedule';
import { PolygonSurgeTabProps, ScheduleSurgePayload } from '../surge-tabs/types';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';

const PolygonSurgeSchedule: FC<PolygonSurgeTabProps> = ({
  confirm,
  setLoading,
  onClose,
  cokitchen_polygon_id
}) => {
  const [value, setValue] = useState({} as ScheduleSurgePayload);

  const setPolygonSurge = async () => {
    try {
      const url = 'logistics/super-admin/surge/polygon/schedule';
      const res = await apiService.post(url, {
        data: {
          ...value,
          cokitchen_polygon_id
        }
      });
      const data = res?.data?.general_surge_history;
      return data;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (confirm === 'Schedule') {
      (async () => {
        try {
          setLoading(true);
          await setPolygonSurge();
          toast(<ToastMessage type='success' message='Updated successfully' />);
          onClose();
        } catch (error) {
          toast(<ToastMessage type='error' message='There was an error updating surge' />);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [confirm]);

  return (
    <div>
      <SurgeApplyNowSection
        value={value}
        setValue={(newVal) => setValue({ ...value, ...newVal })}
        hideRemoveSurge
      />
      <SurgeScheduleSection
        value={value}
        setValue={(newVal) => setValue({ ...value, ...newVal })}
      />
    </div>
  );
};

export default PolygonSurgeSchedule;
